import * as React from "react";
import { PatientPersonalProfile } from "@curefit/ups-common";
import {default as EditViewCard, EditViewDisplayMode} from "../../components/common/EditViewCard";
import IinfoQues from "../../models/staticData/IinfoQues";

/**
 * Created by Prachi on 02/04/18.
 */

interface MindfulnessContProps {
    mindfulness: PatientPersonalProfile;
    staticMindfulnessInfo: IinfoQues;
    displayMode?: EditViewDisplayMode,
}
interface MindfulnessContStates {
    mindfulness: PatientPersonalProfile;
}
export default class MindfulnessEditViewCont extends React.Component<MindfulnessContProps, MindfulnessContStates> {
    constructor(props: MindfulnessContProps) {
        super(props);
        this.state = {mindfulness: props.mindfulness};
    }
    getMindfulnessInfoEditViewProps = () => {
        let editProps = {
            staticMindfulnessInfo: {...this.props.staticMindfulnessInfo},
            personalInfos: {...this.state.mindfulness},
            updateHandler: this.updateHandler,
        }
        return {"view": {}, "edit": {...editProps}};
    }
    saveMindfulnessInfo = () => {
        // Save Patient Personal Info
    }
    updateHandler = (personalProfile: PatientPersonalProfile) => {
        this.setState({mindfulness: personalProfile});
    }
    getSaveObject = () => {
        let personalInfo = {...this.state.mindfulness};
        return personalInfo;
    }
    cancelActionHandler = () => {}
    render() {
        return <div>
            <EditViewCard cardTitleDisplay={"Sleep and mindfulness"} templateName={"mindfulness"}
                          templateProps={this.getMindfulnessInfoEditViewProps()}
                          lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveMindfulnessInfo}
                          cancelActionHandler={this.cancelActionHandler}
                          displayMode={this.props.displayMode}
            />
        </div>
    }
}